import { cn } from '@/lib/cn';
import { t } from '@/i18n';

const sizes = {
  sm: 'h-4 w-4 border-2',
  md: 'h-6 w-6 border-2',
  lg: 'h-10 w-10 border-[3px]',
} as const;

interface SpinnerProps {
  size?: keyof typeof sizes;
  className?: string;
}

export function Spinner({ size = 'md', className }: SpinnerProps) {
  return (
    <span
      role="status"
      aria-label={t('common.loading')}
      className={cn(
        'inline-block animate-spin rounded-full border-current border-r-transparent',
        sizes[size],
        className,
      )}
    />
  );
}

/** Sayfa ortasında tam ekran yükleme göstergesi. */
export function PageSpinner() {
  return (
    <div className="grid min-h-[50vh] place-items-center text-primary-900">
      <Spinner size="lg" />
    </div>
  );
}
